import React, {
  useContext, useState, useMemo, useCallback, useEffect
} from 'react'
import {
  StaticSidebar as CPStaticSidebar,
  HTML as CPHTML,
  FAQ,
  PolicyForm as CPPolicyForm,
  ShopNow,
} from '@usap/widgets'
import { useFeatureFlagCookieContext } from '@usap/core'
import { LocalContext } from '../../helpers/useLocalContext'
import sendPolicyForm from '../../helpers/sendPolicyForm'
import captchConfig from '../../../config/captcha-config'
import useVLPHomeRedirect from '../MyAccount/hooks/OrderHistory/useVLPHomeRedirect'
import { MainSectionBox, MainSectionContainer, MainSectionStaticBarBox } from './MainSection.css'
import TrackOrder from '../MyAccount/TrackOrder'
import { LoginContext } from '../../contexts/login.context'
import OpenChat from '../Kustomer/Events'
import useWmoEnabled from '../../hooks/useWmoEnabled'

const { siteKey } = captchConfig

const errorMessage = 'Sorry, we are unable to process your request at this moment. Please try again later.'
const successMessage = "<strong>Thank you!</br>Your price match request has been submitted.</strong></br>We'll review your request and work with you to verify the competitor price and either match or beat that price on the spot. One of our team members will reach out to you via email or over the phone as soon as possible."

let html = []
let htmlBottom = []

export default function MainSection({
  dynamicApiData: { contents, pageType },
  apiDetails,
  history,
}) {
  let isHtml = true

  if (!contents || !Object.keys(contents)) isHtml = false

  const { hassleFreeReturn: isHassleFree } = useFeatureFlagCookieContext()
  const { localContext } = useContext(LocalContext)
  const { Link } = localContext
  const navigateToVehicle = useVLPHomeRedirect()

  const [icon, setIcon] = useState('help')
  const [message, setMessage] = useState('')
  const [isLoading, setLoader] = useState(false)
  const { hasUserLoggedIn } = useContext(LoginContext)
  const isWmoEnabled = useWmoEnabled();
  
  const isPage = useMemo(
    () => ({
      priceGuarantee: pageType === 'st_lowpriceguarantee',
      returnPolicy: pageType === 'st_returnpolicy',
      lifetimeReplacement: pageType === 'st_lifetimereplacement',
      returnsCenter: pageType === 'st_returnscenter',
      companyFAQ: pageType === 'st_faq',
      trackorder: pageType === 'st_trackorder',
    }),
    [pageType],
  )
  if (isHtml && contents) {
    html = contents.text || []

    const isPolicyTemplate2 = isPage.priceGuarantee ||
      isPage.lifetimeReplacement ||
      isPage.returnsCenter ||
      (isPage.returnPolicy && isHassleFree)

    if (isPolicyTemplate2) {
      html = contents.customContent || []
    }

    htmlBottom = contents.textBottom || []
  }

  const formSubmit = useCallback(async policyData => {
    setLoader(true)
    try {
      const { data: returnData } = await sendPolicyForm(policyData)

      if (returnData && returnData.data && returnData.data.form && returnData.data.form.success) {
        setIcon('check')
        setMessage(successMessage)

        const policyForm = document.getElementById('lowPricePolicyForm')
        if (policyForm) {
          policyForm.scrollIntoView({ behavior: 'smooth' })
        }

        setLoader(false)
        return {}
      }
      setLoader(false)
      throw new Error(errorMessage)
    } catch (error) {
      setIcon('help')
      setMessage(errorMessage)
      setLoader(false)
      throw error
    }
  }, [])

  const handleChatLinkClick = event => {
    event.preventDefault()
    OpenChat()
  }

  useEffect(() => {
    const chatLinks = document.querySelectorAll('a[href*="openChatWindow"], a[href*="openChat"]');

    chatLinks.forEach(link => {
      link.addEventListener('click', handleChatLinkClick)
    })

    return () => {
      chatLinks.forEach(link => {
        link.removeEventListener('click', handleChatLinkClick)
      })
    }
  }, [])

  return (
    <>
      <MainSectionContainer
        id="MainSection"
        returnsCenter={isPage.returnsCenter}
        isWmoEnabled={isWmoEnabled}
      >
        {isPage.companyFAQ
          ? <FAQ data={html} />
          : (
            <>
              {!isPage.returnsCenter && (
                <MainSectionStaticBarBox width="20%">
                  <CPStaticSidebar pageType={pageType} Link={Link} records={apiDetails.policies} loggedIn={hasUserLoggedIn} />
                </MainSectionStaticBarBox>
              )}
              <MainSectionBox returnsCenter={isPage.returnsCenter}>
                {isHtml && (
                  <CPHTML data={html} isPage={isPage} />
                )}
                {isPage.priceGuarantee && (
                  <CPPolicyForm
                    formSubmit={formSubmit}
                    icon={icon}
                    message={message}
                    setMessage={setMessage}
                    siteKey={siteKey}
                    isLoading={isLoading}
                    setLoader={setLoader}
                  />
                )}
                {isHtml && isPage.priceGuarantee && (
                  <CPHTML
                    data={htmlBottom}
                    isPage={isPage}
                  />
                )}
                {isPage.lifetimeReplacement && (
                  <ShopNow navigateToVehicle={navigateToVehicle} />
                )}
                {isPage.trackorder && (
                  <TrackOrder
                    apiDetails={apiDetails}
                    history={history}
                  />
                )}
              </MainSectionBox>
            </>
          )}
      </MainSectionContainer>
    </>
  )
}
